import { motion, type Transition } from "motion/react";
import { FaChevronDown } from "react-icons/fa6";

export const MenuItem = ({
  setActive,
  active,
  item,
  children,
}: {
  setActive: (item: string) => void;
  active: string | null;
  item: string | React.ReactNode;
  children?: React.ReactNode;
}) => {
  const transition: Transition = {
    type: "spring",
    mass: 0.5,
    damping: 11.5,
    stiffness: 100,
    restDelta: 0.001,
    restSpeed: 0.001,
  };
  return (
    <div
      onMouseEnter={() => setActive(typeof item === "string" ? item : "")}
      className="relative "
    >
      <motion.p
        transition={{ duration: 0.3 }}
        className="cursor-pointer hover:opacity-[0.9] text-(--text-primary) hover:bg-(--background-secondary)/10 rounded-full px-4 py-2 transition-all duration-300 flex items-center gap-x-2"
      >
        {item}
        <FaChevronDown className="w-4 h-4" />
      </motion.p>
      {active !== null && (
        <motion.div
          initial={{ opacity: 0, scale: 0.85, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={transition}
        >
          {active === item && (
            <div className="absolute top-[calc(100%-0.75rem)] left-12 transform -translate-x-1/2 pt-4">
              <motion.div
                transition={transition}
                layoutId="active"
                className="bg-(--background) backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl "
              >
                <motion.div layout className="w-max h-full p-4">
                  {children}
                </motion.div>
              </motion.div>
            </div>
          )}
        </motion.div>
      )}
    </div>
  );
};

export const Menu = ({
  setActive,
  children,
  className,
}: {
  setActive: (item: string | null) => void;
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      onMouseLeave={() => setActive(null)}
      className={`relative rounded-full border border-transparent shadow-input flex justify-center space-x-4 py-6 ${className}`}
    >
      {children}
    </div>
  );
};

export const HoveredLink = ({
  children,
  ...rest
}: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  return (
    <a
      {...rest}
      className="text-(--text-secondary) hover:text-(--text-primary) cursor-pointer"
    >
      {children}
    </a>
  );
};
